import { merge } from '@/utils/merge';
import BaseConfig from 'base/config';
import BrandConfig from '@/svenskdam/config';

export default merge(BaseConfig, BrandConfig);